import React, {useEffect, useReducer} from 'react';
import PropTypes from 'prop-types';

const useResizeReducer = () => {
  const initialState = {
    isPressing: false,
  };
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'ACTIVATE':
        return {
          ...state,
          isPressing: true,
        };
      case 'DEACTIVATE':
        return {...initialState};
      default:
        return state;
    }
  }, initialState);

  const handleActivate = () => dispatch({type: 'ACTIVATE'});

  const handleDeactivate = () => dispatch({type: 'DEACTIVATE'});

  return {
    state,
    handleActivate,
    handleDeactivate,
  };
};

const ResizeHandle = (props) => {
  const {className, horizontal, onResize, setOverlayActivated} = props;
  const {
    state: {isPressing, mouseX, mouseY},
    handleActivate,
    handleDeactivate,
  } = useResizeReducer();

  const handleMouseDown = () => {
    handleActivate();
    setOverlayActivated(true);
  };

  const handleMouseUp = () => {
    handleDeactivate();
    setOverlayActivated(false);
  };

  const handleMouseMove = ({pageX, pageY}) => {
    const value = horizontal ? pageX : pageY;
    onResize(value);
  };

  useEffect(
    () => {
      if (!isPressing) return;
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      };
    },
    [isPressing, mouseX, mouseY],
  );

  return <div className={className} onMouseDown={handleMouseDown} />;
};

ResizeHandle.propTypes = {
  className: PropTypes.string.isRequired,
  horizontal: PropTypes.bool.isRequired,
  onResize: PropTypes.func.isRequired,
  setOverlayActivated: PropTypes.func.isRequired,
};

ResizeHandle.defaultProps = {
  horizontal: false,
};

export default ResizeHandle;
